import { render, staticRenderFns } from "./ViewGiftCardNumber.vue?vue&type=template&id=5b624729"
import script from "./ViewGiftCardNumber.vue?vue&type=script&lang=ts"
export * from "./ViewGiftCardNumber.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports